/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://d8qvxufq6a.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:1445f8d0-77bd-438b-97ec-76a3b195b5da",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_p3L38NXoz",
    "aws_user_pools_web_client_id": "1csrmd2iunqcjjb2uqgcldg0tq",
    "oauth": {
        "domain": "cyf-dev.auth.eu-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://dev.app.compareyourfootprint.com/,https://staging2.app.compareyourfootprint.com/,https://staging.app.compareyourfootprint.com/,https://app.compareyourfootprint.com/",
        "redirectSignOut": "https://dev.app.compareyourfootprint.com/,https://staging2.app.compareyourfootprint.com/,https://staging.app.compareyourfootprint.com/,https://app.compareyourfootprint.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
